<template>
  <div class="c-galery-media">
    <div class="c-galery-media__poster c-margin-sm--bottom">
      <c-overlay>
        <c-image
          :image-desktop="poster"
          :image-mobile="poster"
          :alt="alt"
        />
      </c-overlay>
      <c-overlay v-if="temp === 'album video' || temp === 'media video'">
        <div class="play-button">
          <c-icon
            name="play"
            size="xxl"
            color="#10ADEA"
          />
        </div>
      </c-overlay>
      <c-overlay class="floater">
        <div
          v-if="!isAlbum"
          class="download-button"
        >
          <c-icon
            name="download"
            size="md"
            color="#041729"
          />
        </div>
      </c-overlay>
    </div>
    <div class="c-galery-media__description">
      <c-text
        v-if="title"
        class="c-margin-xs--bottom"
        size="xl"
        weight="normal"
        color="#1A202C"
        align="center"
      >
        {{ title }}
      </c-text>
      <c-text
        v-if="description"
        size="md"
        align="center"
      >
        {{ description }}
      </c-text>
    </div>
  </div>
</template>

<script>
export default {
  name: 'c-gallery-media',
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    poster: {
      type: String
    },
    media: {
      type: String
    },
    templateName: {
      type: String
    },
    alt: {
      type: String
    }
  },
  computed: {
    isAlbum() {
      return this.templateName && this.templateName.toLowerCase().indexOf('album') >= 0
    },
    temp() {
      return this.templateName.toLowerCase()
    }
  }
}
</script>

<style lang="scss" scopped>
  .c-galery-media {
    $container: &;

    img{
      min-height: 13rem;
    }

    &__poster {
      position: relative;
      height: 12.875rem;

      & .play-button {
        display: flex;
        overflow: hidden;
        border-radius: 100%;
        background-color: $white;
        border: 0.063rem solid $blue-04;

        & svg {
          stroke: $blue-04;
        }
      }

      & .c-image {
        transition: all 0.8s;
      }

      & .floater {
        visibility: hidden;
        background: rgba(76, 175, 80, 0);
        transition: all .14s;

        & .download-button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 3.875rem;
          height: 3.875rem;
          border-radius: 100%;
          overflow: hidden;
          background-color: $white;
        }
      }
    }

    &__description {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      & .c-text {
        line-height: 160%;
      }

    }

    &:hover {
      #{$container}__poster {
        & .c-image {
          transform: scale(1.08);
        }

        & .floater {
          visibility: visible;
        }
      }
    }
  }
</style>
